import { PageService } from "./page/page.service";

export interface IPage {
  refresh: () => void;
}

export abstract class Page {
  protected constructor() {
    PageService.setCurrentPage(this);
  }

  public abstract refresh(): void;
}
